// src/pages/clients/grm/reports/R0006/configs/businessRules.config.js

export const grmBusinessRules = {
  BASE_MULTIPLIER: {
    BRAND: 1,
    OTHER: 0.4  // GRM-specific multiplier
  },
  
  STORE_COUNTS: {
    BRAND: { total: 20, aboveTarget: 16 },  // GRM has 20 stores
    OTHER: { total: 6, aboveTarget: 5 }     // Regional areas
  },
  
  // GRM-specific thresholds
  PERFORMANCE_THRESHOLDS: {
    EXCELLENT: 90,
    GOOD: 75,
    FAIR: 50
  },
  
  OPPORTUNITY_THRESHOLDS: {
    LOW: 1000,
    MEDIUM: 5000
  }
};